(function () {
  'use strict';
  var banner = document.getElementById('tns-cookie-banner');
  var dialog = document.getElementById('tns-privacy-dialog');
  if (!banner || !dialog) return;
  var api, loading, busy = false, returnFocus, toastTimer;
  var purposes = ['preferences', 'analytics', 'marketing', 'sale_of_data'];
  function message(text) {
    document.querySelectorAll('.tns-privacy-message').forEach(function (el) { el.textContent = text; });
  }
  function loadApi() {
    if (api) return Promise.resolve(api);
    if (loading) return loading;
    loading = new Promise(function (resolve, reject) {
      var attempts = 0;
      function start() {
        if (window.Shopify && window.Shopify.customerPrivacy) {
          api = window.Shopify.customerPrivacy; resolve(api); return;
        }
        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) {
            if (error || !window.Shopify.customerPrivacy) { reject(new Error('privacy-unavailable')); return; }
            api = window.Shopify.customerPrivacy; resolve(api);
          });
        } else if (++attempts < 40) { setTimeout(start, 250); }
        else { reject(new Error('privacy-unavailable')); }
      }
      start();
    }).catch(function (error) { loading = null; throw error; });
    return loading;
  }
  function readChoices() {
    var choices = api.currentVisitorConsent();
    purposes.forEach(function (key) {
      dialog.querySelector('[data-tns-purpose="' + key + '"]').checked = choices[key] === 'yes';
    });
    return choices;
  }
  function openPreferences(trigger) {
    returnFocus = trigger;
    message('');
    if (!dialog.open) dialog.showModal();
    loadApi().then(readChoices).catch(function () {
      message('No pudimos cargar tus preferencias. Inténtalo otra vez o escríbenos a ffierro@newspot.cl.');
    });
  }
  function closePreferences() {
    dialog.close();
    if (returnFocus && returnFocus.isConnected) returnFocus.focus();
  }
  function save(action) {
    if (busy) return;
    busy = true;
    message('');
    document.querySelectorAll('[data-tns-consent]').forEach(function (button) { button.disabled = true; });
    var values = {};
    purposes.forEach(function (key) {
      values[key] = action === 'save' ? dialog.querySelector('[data-tns-purpose="' + key + '"]').checked : action === 'accept';
    });
    // Respect Global Privacy Control even when the visitor accepts other optional cookies.
    if (navigator.globalPrivacyControl === true) values.sale_of_data = false;
    loadApi().then(function () {
      return new Promise(function (resolve, reject) {
        var timeout = setTimeout(function () { reject(new Error('save-timeout')); }, 10000);
        try {
          api.setTrackingConsent(values, function () {
            clearTimeout(timeout);
            var actual = api.currentVisitorConsent();
            if (purposes.some(function (key) { return actual[key] !== (values[key] ? 'yes' : 'no'); })) {
              reject(new Error('save-unconfirmed')); return;
            }
            resolve();
          });
        } catch (error) { clearTimeout(timeout); reject(error); }
      });
    }).then(function () {
      banner.hidden = true;
      if (dialog.open) closePreferences();
      var feedback = document.getElementById('tns-privacy-feedback');
      feedback.textContent = 'Tus preferencias quedaron guardadas. Puedes cambiarlas en el pie de página.';
      feedback.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { feedback.hidden = true; }, 6000);
    }).catch(function () {
      message('No pudimos guardar tu elección. Inténtalo nuevamente; no confirmaremos el cambio hasta que Shopify lo registre.');
    }).finally(function () {
      busy = false;
      document.querySelectorAll('[data-tns-consent]').forEach(function (button) { button.disabled = false; });
    });
  }
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-tns-privacy-open]');
    if (opener) { event.preventDefault(); openPreferences(opener); return; }
    if (event.target.closest('[data-tns-privacy-close]')) { closePreferences(); return; }
    var action = event.target.closest('[data-tns-consent]');
    if (action) save(action.dataset.tnsConsent);
  });
  dialog.addEventListener('cancel', function (event) { event.preventDefault(); closePreferences(); });
  document.addEventListener('visitorConsentCollected', function () {
    if (api) {
      var choices = api.currentVisitorConsent();
      if (purposes.every(function (key) { return choices[key] !== ''; })) banner.hidden = true;
    }
  });
  loadApi().then(function () {
    var choices = readChoices();
    banner.hidden = purposes.every(function (key) { return choices[key] === 'yes' || choices[key] === 'no'; });
  }).catch(function () {
    banner.hidden = false;
    message('No pudimos cargar el gestor de preferencias. Puedes reintentar con los botones o contactarnos.');
  });
})();